import Header from '@/apps/user/components/layout/Header';
import Footer from '@/apps/user/components/layout/Footer';

import { Outlet } from 'react-router-dom';

export default function MainPanelLayout() {
    return (
        <div className='flex flex-col min-h-screen'>
            <Header />
            <main className='flex-grow'>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
